var map = {
	"./_old_v1/chapter-1/diagram-1-ims.json": "0741",
	"./_old_v1/chapter-1/diagram-2-tas.json": "f366",
	"./_old_v1/chapter-1/diagram-6-convergence.json": "a800",
	"./_old_v1/chapter-1/icon-ims-via-tas-01.json": "adb8",
	"./_old_v1/chapter-1/icon-ims-via-tas-02.json": "96e0",
	"./_old_v1/chapter-1/icon-ims-via-tas-03.json": "0873",
	"./_old_v1/chapter-1/icon-ims-via-tas-04.json": "db3d",
	"./_old_v1/chapter-1/icon-ims-via-tas-05.json": "e0f6",
	"./_old_v1/chapter-1/icon-ims-via-tas-06.json": "4eae",
	"./_old_v1/chapter-2/diagram-3-5g-core.json": "9004",
	"./_old_v1/chapter-2/diagram-4-agnostic-voice.json": "f9a4",
	"./_old_v1/chapter-2/diagram-5-img-networks.json": "649d",
	"./_old_v1/chapter-2/diagram-7-border-control.json": "8d30",
	"./_old_v1/chapter-4/usecase-01.json": "b6a3",
	"./_old_v1/chapter-4/usecase-02.json": "e421",
	"./_old_v1/chapter-4/usecase-03.json": "5ac4",
	"./_old_v1/chapter-4/usecase-04.json": "b0b3",
	"./_old_v1/chapter-4/usecase-05.json": "245a",
	"./_old_v1/chapter-4/usecase-06.json": "3b76",
	"./_old_v1/chapter-4/usecase-07.json": "49ae",
	"./_old_v1/introduction/icon-1-voice-phone.json": "cb46",
	"./_old_v1/introduction/icon-3-ambulance.json": "d784",
	"./_old_v1/introduction/icon-4-phone-buttons.json": "75ba",
	"./_old_v1/test/icon-1-voice.json": "7a8c",
	"./_old_v1/test/icon-2-phone.json": "65e0",
	"./_old_v2/chapter-1/diagram-1-ims.json": "5434",
	"./_old_v2/chapter-1/diagram-2-tas.json": "2390",
	"./_old_v2/chapter-1/diagram-6-convergence.json": "f96c",
	"./_old_v2/chapter-1/icon-ims-via-tas-01.json": "e03a",
	"./_old_v2/chapter-1/icon-ims-via-tas-02.json": "95c8",
	"./_old_v2/chapter-1/icon-ims-via-tas-03.json": "b3e1",
	"./_old_v2/chapter-1/icon-ims-via-tas-04.json": "9242",
	"./_old_v2/chapter-1/icon-ims-via-tas-05.json": "f5d6",
	"./_old_v2/chapter-1/icon-ims-via-tas-06.json": "435d",
	"./_old_v2/chapter-2/diagram-3-5g-core.json": "eb6e",
	"./_old_v2/chapter-2/diagram-4-agnostic-voice.json": "3f23",
	"./_old_v2/chapter-2/diagram-5-img-networks.json": "efc6",
	"./_old_v2/chapter-2/diagram-7-border-control.json": "f9ab",
	"./_old_v2/chapter-4/usecase-01.json": "f0d4",
	"./_old_v2/chapter-4/usecase-02.json": "2281",
	"./_old_v2/chapter-4/usecase-03.json": "c99a",
	"./_old_v2/chapter-4/usecase-04.json": "ef25",
	"./_old_v2/chapter-4/usecase-05.json": "714b",
	"./_old_v2/chapter-4/usecase-06.json": "574e",
	"./_old_v2/chapter-4/usecase-07.json": "91d0",
	"./_old_v2/introduction/icon-1-voice-phone.json": "dce1",
	"./_old_v2/introduction/icon-3-ambulance.json": "22bd",
	"./_old_v2/introduction/icon-4-phone-buttons.json": "abc3",
	"./_old_v2/introduction/icon-4-voice-IoT.json": "02f5",
	"./chapter-1/diagram-1-ims.json": "fa47",
	"./chapter-1/diagram-2-tas.json": "57fa",
	"./chapter-1/diagram-6-convergence.json": "929e",
	"./chapter-1/icon-ims-via-tas-01.json": "99b8",
	"./chapter-1/icon-ims-via-tas-02.json": "9686",
	"./chapter-1/icon-ims-via-tas-03.json": "6ac7",
	"./chapter-1/icon-ims-via-tas-04.json": "7804",
	"./chapter-1/icon-ims-via-tas-05.json": "3360",
	"./chapter-1/icon-ims-via-tas-06.json": "7525",
	"./chapter-2/diagram-3-5g-core.json": "ae22",
	"./chapter-2/diagram-4-agnostic-voice.json": "0e51",
	"./chapter-2/diagram-5-img-networks.json": "f4b9",
	"./chapter-2/diagram-7-border-control.json": "bafe",
	"./chapter-4/usecase-01.json": "607c",
	"./chapter-4/usecase-02.json": "bfd5",
	"./chapter-4/usecase-03.json": "7b6d",
	"./chapter-4/usecase-04.json": "80a6",
	"./chapter-4/usecase-05.json": "b38f",
	"./chapter-4/usecase-06.json": "d366",
	"./chapter-4/usecase-07.json": "f3f8",
	"./introduction/01-icon-animations-1-blue.json": "b299",
	"./introduction/01-icon-animations-1-white.json": "1243",
	"./introduction/01-icon-animations-2-blue.json": "2491",
	"./introduction/01-icon-animations-2-white.json": "3abf",
	"./introduction/icon-1-voice-phone.json": "5369"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "972c";